import { Badge, Input, Label, MultiFilter, SingleFilter } from './components'
import type {
  FilterSize,
  IBadgeProps,
  IInputProps,
  ILabelProps,
  IMultiFilterProps,
  ISingleFilterProps,
  InputSize,
  componentType,
} from './types'

export const Chip = {
  SingleFilter,
  MultiFilter,
  Input,
  Label,
  Badge,
}

export type {
  ISingleFilterProps,
  IBadgeProps,
  IInputProps,
  ILabelProps,
  IMultiFilterProps,
  FilterSize,
  InputSize,
  componentType,
}
